import { useFaqSelector } from '../../application/redux-store/store-types';

export const useFaqBuffer = () => {
  return useFaqSelector((store) => store.faq.buffer);
};
